import { z } from 'zod';

import { passwordRequirements } from '../../passwordRequirements.ts';

export const schema = z.object({
  password: z
    .string()
    .min(1, { message: 'required' })
    .refine((value) => passwordRequirements.every((requirement) => requirement.check(value)), 'notValid'),
});

export type FormPassword = z.infer<typeof schema>;
